import { throwError as observableThrowError } from 'rxjs';

export function handleError(error: Response) {
	return observableThrowError(error);
}
